import { AxiosRequestConfig } from 'axios';
import tokenCache from './token-cache';

interface TokenInterceptorOptions {
  token?: string;
  getToken?: () => string | Promise<string | null>;
  header?: string;
  headerFormatter?: (token: string | null) => string;
}

function getToken(options: TokenInterceptorOptions): Promise<string | null> {
  if (options.token) {
    return Promise.resolve(options.token);
  }

  if (!options.getToken) {
    return Promise.resolve(null);
  }

  const token = options.getToken();
  if (typeof token !== 'object' || !('then' in token)) {
    return Promise.resolve(token as string);
  }

  return token;
}

function tokenInterceptor(options: TokenInterceptorOptions) {
  const header = options.header || 'Authorization';
  const headerFormatter = options.headerFormatter || function defaultHeaderFormatter(token: string | null) {
    return `Bearer ${token}`;
  };

  return function interceptRequest(config: AxiosRequestConfig) {
    const requestConfig = config;
    return getToken(options).then((token) => {
      if (token && requestConfig.headers) {
        requestConfig.headers[header] = headerFormatter(token);
      }
      return config;
    });
  };
}

tokenInterceptor.tokenCache = tokenCache;

export default tokenInterceptor;